<ng-container *transloco="let t; prefix: 'dynamic-table'">
  @if (rows().length > 0 || pendingRow()) {
    <div [formGroup]="form()" class="dynamic-table-container">
      <table>
        <thead>
          <tr>
            @for (field of fields(); track field.key) {
              <th [style.width]="field.width + '%'">{{ field.label | async }}</th>
            }
            <th class="actions-column"></th>
          </tr>
        </thead>
        <tbody formArrayName="rows">
          @for (row of rows().controls; track row; let index = $index) {
            <tr [formGroupName]="index">
              @for (field of fields(); track field.key) {
                <td [attr.data-label]="field.label | async">
                  @if (editingIndex() === index) {
                    @if (field.type === 'select') {
                      <accredible-select-input
                        [formControlRef]="getFormControl(row.get(field.key))"
                        [options]="field.options"
                        [dataCy]="'select-input-row-' + index + '-' + field.key"
                        [menuWidthEqualsButtonWidth]="true"
                        [placeholder]="(field.placeholder | async) || ''"
                        [noError]="true"
                        [size]="getSelectSize()" />
                    } @else {
                      <input
                        [formControlName]="field.key"
                        [attr.data-cy]="'input-row-' + index + '-' + field.key"
                        [type]="field.type"
                        [placeholder]="(field.placeholder | async) || ''" />
                    }
                    @if (
                      row.get(field.key)?.errors &&
                      (row.get(field.key)?.touched || row.get(field.key)?.dirty)
                    ) {
                      <accredible-input-feedback
                        type="error"
                        [message]="getErrorMessage(row.get(field.key))" />
                    }
                  } @else {
                    {{ getDisplayValue(field, row.get(field.key)?.value) }}
                  }
                </td>
              }
              <td class="actions-column">
                <div class="actions">
                  @if (editingIndex() === index) {
                    <button
                      accredible-button-icon
                      class="save-icon-btn"
                      [attr.data-cy]="'btn-save-row-' + index"
                      size="small"
                      icon="check"
                      iconSize="14px"
                      color="success"
                      [disabled]="!isRowValid(index)"
                      (click)="saveRow(index)"></button>
                  } @else {
                    <button
                      accredible-button-icon
                      class="edit-icon-btn"
                      [attr.data-cy]="'btn-edit-row-' + index"
                      size="small"
                      icon="edit"
                      iconSize="14px"
                      color="natural"
                      (click)="editRow(index)"></button>
                  }
                  @if (!editFirstRowByDefault() || rows().length > 1 || editingIndex() !== index) {
                    <button
                      accredible-button-icon
                      class="delete-icon-btn"
                      [attr.data-cy]="'btn-delete-row-' + index"
                      size="small"
                      icon="delete"
                      iconSize="14px"
                      color="danger"
                      (click)="removeRow(index)"></button>
                  }
                </div>
              </td>
            </tr>
          }
          @if (pendingRow()) {
            <tr [formGroup]="pendingRow()!">
              @for (field of fields(); track field.key; let index = $index) {
                <td [attr.data-label]="field.label | async">
                  @if (field.type === 'select') {
                    <accredible-select-input
                      [formControlRef]="getFormControl(pendingRow().get(field.key))"
                      [options]="field.options"
                      [menuWidthEqualsButtonWidth]="true"
                      [placeholder]="(field.placeholder | async) || ''"
                      [noError]="true"
                      [dataCy]="'select-input-row-' + index + '-' + field.key"
                      [size]="getSelectSize()" />
                  } @else {
                    <input
                      [formControlName]="field.key"
                      [type]="field.type"
                      [attr.data-cy]="'input-row-' + index + '-' + field.key"
                      [placeholder]="(field.placeholder | async) || ''" />
                  }
                  @if (
                    pendingRow().get(field.key)?.errors &&
                    (pendingRow().get(field.key)?.touched || pendingRow().get(field.key)?.dirty)
                  ) {
                    <accredible-input-feedback
                      type="error"
                      [message]="getErrorMessage(pendingRow().get(field.key))" />
                  }
                </td>
              }
              <td class="actions-column">
                <div class="actions">
                  <button
                    accredible-button-icon
                    class="save-icon-btn"
                    size="small"
                    icon="check"
                    iconSize="14px"
                    [attr.data-cy]="'btn-save-row-' + rows().length"
                    color="success"
                    [disabled]="!isRowValid(rows().length)"
                    (click)="saveRow(rows().length)"></button>
                  @if (!editFirstRowByDefault() || rows().length > 0) {
                    <button
                      accredible-button-icon
                      class="delete-icon-btn"
                      [attr.data-cy]="'btn-delete-row-' + rows().length"
                      size="small"
                      icon="delete"
                      iconSize="14px"
                      color="danger"
                      (click)="removeRow(rows().length)"></button>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <button
    accredible-button-flat
    class="add-row-button"
    data-cy="btn-add-row"
    icon="plus"
    size="small"
    iconPosition="left"
    [disabled]="!canAddRow()"
    (click)="addRow()">
    {{ rows().length > 0 ? addAdditionalButtonText() : addButtonText() }}
  </button>
</ng-container>
